import { createFileRoute, } from '@tanstack/react-router'
import { companiesQueryOptions } from '@/hooks/useCompaniesQuery'
import ProjectSelectPage from '@/app/project-select'

export const Route = createFileRoute('/_auth/project-select')({
  loader: async ({ context }) => {
    await context.queryClient.prefetchQuery(companiesQueryOptions)
    return {}
  },
  component: ProjectSelectPage,
})
